import { render, staticRenderFns } from "./PlatformSetting.vue?vue&type=template&id=4dd638aa&scoped=true&"
import script from "./PlatformSetting.vue?vue&type=script&lang=js&"
export * from "./PlatformSetting.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSetting.vue?vue&type=style&index=0&id=4dd638aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd638aa",
  null
  
)

export default component.exports